import React from 'react';
import './Styles/Banner.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import {ReactComponent as Video} from '../../../Assets/Icons/video.svg';
import image from '../../../Assets/Cards/forward.webp';
const Banner=()=>{
    return(
        <div className="enterprise-banner">
            <div className="content">
                <h1>Design, test and ship amazing products at scale with Hostdesign</h1>
                <p>Hostdesign Enterprise transforms your design process, leading to better products, faster.</p>
                <StyledButton btn="Request a demo"/>
                <div className="video">
                    <Video />
                    <p>Watch Video</p>
                </div>
            </div>
            <img src={image} />
        </div>
    )
};
export default Banner ;